import React from 'react';
import { motion } from 'framer-motion';
import { MiniDjayPrompt } from './MiniDjayPrompt';
import { SectionHeader } from '../ui/SectionHeader';
import { RADIUS } from '../../config/designTokens';
import type { DjayEmotion, DjayVariant } from '../../mascot';
interface WorldZoneProps {
  title: string;
  icon: React.ElementType;
  accentColor: string;
  children: React.ReactNode;
  djayMessage?: string;
  djayEmotion?: DjayEmotion;
  djayVariant?: DjayVariant;
  isLast?: boolean;
  className?: string;
}
export function WorldZone({
  title,
  icon: Icon,
  accentColor,
  children,
  djayMessage,
  djayEmotion = 'happy',
  djayVariant = 'default',
  isLast = false,
  className = ''
}: WorldZoneProps) {
  // Create a vibrant gradient background for the zone based on the accentColor
  const bgClass = accentColor.split(' ').find(c => c.startsWith('bg-')) || 'bg-indigo-100';
  const gradientFrom = bgClass.replace('-100', '-50');
  const gradientTo = bgClass.replace('-100', '-100/30');
  return <div className={`relative ${className}`} data-id="element-2668" data-mp="ukiutjgjvf8a">
      <div className={`relative ${RADIUS.surface} p-6 sm:p-10 bg-gradient-to-b ${gradientFrom} ${gradientTo} border-2 border-white shadow-sm overflow-hidden`} data-id="element-2669" data-mp="uj7rfkr0o9hp">
        {/* Decorative background elements */}
        <div className="absolute top-0 right-0 w-64 h-64 bg-white/40 rounded-full blur-3xl -translate-y-1/2 translate-x-1/4 pointer-events-none" data-id="element-2670" data-mp="knml5aex0n25" />
        <div className="absolute bottom-0 left-0 w-48 h-48 bg-white/30 rounded-full blur-2xl translate-y-1/4 -translate-x-1/4 pointer-events-none" data-id="element-2671" data-mp="bm6ixpy97r90" />

        {/* Header Area */}
        <div className="mb-10 relative z-10" data-id="element-2672" data-mp="1usd70fplv7f">
          <SectionHeader title={title} icon={Icon} accentColor={accentColor} size="lg" action={djayMessage ? <div className="hidden sm:block" data-id="element-2674" data-mp="3o20f1srf7jyp">
                  <MiniDjayPrompt message={djayMessage} emotion={djayEmotion} data-id="element-2675" data-mp="3k16rx1lsy96v" />
                </div> : undefined} data-id="element-2673" data-mp="1vlc5f8ffgf0" />
        </div>

        {/* Mobile Djay Prompt */}
        {djayMessage && <div className="mb-8 sm:hidden relative z-10" data-id="element-2676" data-mp="3efz5085r1fkf">
            <MiniDjayPrompt message={djayMessage} emotion={djayEmotion} data-id="element-2677" data-mp="30f4v1l31z6jn" />
          </div>}

        {/* Content Area */}
        <div className="relative z-10" data-id="element-2678" data-mp="35dg4hupfrf1c">{children}</div>
      </div>

      {/* Visual Connector between zones */}
      {!isLast && <div className="relative h-16 w-full flex justify-center items-center" data-id="element-2679" data-mp="3t4c3bbsb7ai3">
          <div className="h-full w-2 border-l-4 border-dashed border-slate-200/80" data-id="element-2680" data-mp="yyh3vd6t6x8" />
          <motion.div className="absolute w-4 h-4 rounded-full bg-slate-200" animate={{
        y: [0, 10, 0]
      }} transition={{
        duration: 2,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-2681" data-mp="3jesl88cf7koa" />
        </div>}
    </div>;
}